import {
	InfoBannerBodyText,
	InfoBannerContainer,
	InfoBannerText,
	InfoBannerTitleText,
	InfoIcon
} from "components/Common/InfoBanner/InfoBanner.styles.ts";
import { ReactNode, Ref } from "react";

interface InfoBannerProps {
	title: string;
	bodyText?: string;
	bodyNode?: ReactNode;
	ref?: Ref<HTMLDivElement>;
}

const InfoBanner = ({ title, bodyText, bodyNode, ref }: InfoBannerProps) => {
	return (
		<InfoBannerContainer ref={ref}>
			<InfoIcon />
			<InfoBannerText>
				<InfoBannerTitleText>{title}</InfoBannerTitleText>
				{Boolean(bodyText && !bodyNode) && <InfoBannerBodyText>{bodyText}</InfoBannerBodyText>}
				{Boolean(!bodyText && bodyNode) && bodyNode}
			</InfoBannerText>
		</InfoBannerContainer>
	);
};

export default InfoBanner;
